/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import * as selectorsVeiculos from '../../store/veiculo/reducer';
import * as actionsVeiculos from '../../store/veiculo/actions';
import * as selectorsAuth from '../../store/auth/reducer';
import moment from 'moment';
import NotaFormulario from '../Notas/Formulario';

import { Input, DefaultSelect, DialogDefault, NumberInput, TrueFalseSelect, ArquivoContainer, DatePicker, UsuarioSelect, DateTimePicker } from '../../components';
import ManutencaoVeicularContainer from './ManutencaoVeicularContainer';

const schema = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaRepasse = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoRepasse: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  garagem: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  usuario: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaManutencao = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorManutencao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaPecas = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorPecas: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaVendaTroca = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorRecebido: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaMulta = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  multaPrazo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const getSchema = tipoHistorico => {
  switch (tipoHistorico) {
    case 'MANUTENCAO':
      return schemaManutencao
    case 'PECAS':
      return schemaPecas
    case 'AUTUACAO':
    case 'MULTA':
        return schemaMulta
    case 'REPASSE_COLABORADOR':
      return schemaRepasse
    case 'VENDA_TROCA':
      return schemaVendaTroca
    default:
      return schema
  }
}

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const repasse = (values, handleChange, setValues, errors, classes) => {
  return (
    <>
      <Grid item xs={6} className={classes.fieldContainer}>
        <UsuarioSelect
          label="Colaborador"
          onSelect={usuario => setValues({
            ...values,
            usuario
          })}
          ativo
          value={values.usuario}
          error={errors && errors.usuario ? true : false}
        />
      </Grid>
      <Grid item xs={2} className={classes.fieldContainer}>
        <NumberInput
          prefix=""
          label="Km Atual"
          name="kmAtual"
          onChange={valor => setValues({
            ...values,
            kmAtual: valor
          })}
          value={values.kmAtual}
          decimalScale={0}
        />
      </Grid>
      <Grid item xs={4} className={classes.fieldContainer}>
        <Input
          label="Região"
          name="regiao"
          onChange={handleChange}
          value={values.regiao}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <DefaultSelect
          error={errors && errors.tipoRepasse ? true : false}
          isRequired
          label="Tipo"
          name="tipoRepasse"
          showEmpty
          options={[
            { id: 'ENTREGA', nome: 'Entrega' },
            { id: 'DEVOLUCAO', nome: 'Devolução' },
          ]}
          onSelect={handleChange}
          value={values.tipoRepasse}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <TrueFalseSelect
          error={errors && errors.garagem ? true : false}
          isRequired
          label="Está na Garagem"
          name="garagem"
          onChange={handleChange}
          value={values.garagem}
        />
      </Grid>
    </>
  )
}

const manutencao = (values, handleChange, setValues, errors, classes, setNotaView, manutencoes, setManutencoes, readOnly) => {
  return (
    <>
      <Grid item xs={4} className={classes.fieldContainer}>
        <NumberInput
          prefix="R$"
          label="Valor da Manutenção"
          name="valorManutencao"
          onChange={valor => setValues({
            ...values,
            valorManutencao: valor
          })}
          value={values.valorManutencao}
          decimalScale={2}
          error={errors && errors.valorManutencao ? true : false}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={2} className={classes.fieldContainer}>
        <NumberInput
          prefix=""
          label="Km Atual"
          name="kmAtual"
          onChange={valor => setValues({
            ...values,
            kmAtual: valor
          })}
          value={values.kmAtual}
          decimalScale={0}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <TrueFalseSelect
          label="Foi Pago"
          name="pago"
          onChange={handleChange}
          value={values.pago}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <TrueFalseSelect
          label="Emitiu Nota Fiscal"
          onChange={handleChange}
          name="notaFiscal"
          value={values.notaFiscal}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <Input
          label="Profissional Responsável"
          name="profissionalResponsavel"
          onChange={handleChange}
          value={values.profissionalResponsavel}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <Input
          label="Empresa"
          name="empresa"
          onChange={handleChange}
          value={values.empresa}
        />
      </Grid>
      {values.notaId && <Grid item xs={3} className={classes.fieldContainer}>
        <Button variant="outlined" size="medium" onClick={() => setNotaView({ id: values.notaId, open: true })}> Nota Vinculada </Button>
      </Grid>}
      <Grid item xs={12} className={classes.fieldContainer}>
        <ManutencaoVeicularContainer
          manutencoes={manutencoes}
          onSave={setManutencoes}
          readOnly={readOnly}
        />
      </Grid>
    </>
  )
}

const pecas = (values, handleChange, setValues, errors, classes) => {
  return (
    <>
      <Grid item xs={4} className={classes.fieldContainer}>
        <NumberInput
          prefix="R$"
          label="Valor da Peças"
          name="valorPecas"
          onChange={valor => setValues({
            ...values,
            valorPecas: valor
          })}
          value={values.valorPecas}
          decimalScale={2}
          error={errors && errors.valorPecas ? true : false}
        />
      </Grid>
      <Grid item xs={2} className={classes.fieldContainer}>
        <TrueFalseSelect
          label="Foi Pago"
          name="pago"
          onChange={handleChange}
          value={values.pago}
        />
      </Grid>
      <Grid item xs={2} className={classes.fieldContainer}>
        <TrueFalseSelect
          label="Emitiu Nota Fiscal"
          onChange={handleChange}
          name="notaFiscal"
          value={values.notaFiscal}
        />
      </Grid>
      <Grid item xs={4} className={classes.fieldContainer}>
        <Input
          label="Empresa"
          name="empresa"
          onChange={handleChange}
          value={values.empresa}
        />
      </Grid>
    </>
  )
}

const multa = (values, handleChange, setValues, errors, classes) => {
  return (
    <>
      <Grid item xs={6} className={classes.fieldContainer}>
        <DatePicker
          label="Prazo"
          isRequired
          error={errors && errors.multaPrazo ? true : false}
          onChange={data => setValues({
            ...values,
            multaPrazo: data.valueOf()
          })}
          value={values.multaPrazo}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <NumberInput
          prefix="R$"
          label="Valor"
          name="multaValor"
          onChange={valor => setValues({
            ...values,
            multaValor: valor
          })}
          value={values.multaValor}
          decimalScale={2}
          error={errors && errors.multaValor ? true : false}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <UsuarioSelect
          label="Condutor"
          onSelect={usuario => setValues({
            ...values,
            multaCondutor: usuario
          })}
          ativo
          value={values.multaCondutor}
        />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <TrueFalseSelect
          label="Enviada ao Condutor"
          name="multaEnviadaCondutor"
          onChange={handleChange}
          value={values.multaEnviadaCondutor}
        />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <TrueFalseSelect
          label="Enviada ao DNIT"
          name="multaEnviadaDnit"
          onChange={handleChange}
          value={values.multaEnviadaDnit}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <Input
          label="Cód de Postagem ECT"
          name="multaCodPostagemEct"
          onChange={handleChange}
          value={values.multaCodPostagemEct}
        />
      </Grid>
      {values.tipoHistorico === 'MULTA' && <> 
        <Grid item xs={3} className={classes.fieldContainer}>
          <TrueFalseSelect
            label="Multa Paga"
            name="multaPaga"
            onChange={handleChange}
            value={values.multaPaga}
          />
        </Grid>
        <Grid item xs={3} className={classes.fieldContainer}>
          <DatePicker
            label="Data Pagamento"
            error={errors && errors.multaDtPagamento ? true : false}
            onChange={data => setValues({
              ...values,
              multaDtPagamento: data.valueOf()
            })}
            value={values.multaDtPagamento}
          />
        </Grid>
      </>}
    </>
  )
}

const vendaTroca = (values, setValues, errors, classes) => {
  return (
    <>
      <Grid item xs={12} className={classes.fieldContainer}>
        <NumberInput
          prefix="R$"
          label="Valor Recebido"
          name="valorRecebido"
          onChange={valor => setValues({
            ...values,
            valorRecebido: valor
          })}
          value={values.valorRecebido}
          decimalScale={2}
          error={errors && errors.valorRecebido ? true : false}
        />
      </Grid>
    </>
  )
}

const Formulario = ({ upsertHistorico, selectedHistoricoVeiculo, open, id, onClose, findHistoricoById, authData, idVeiculo, afterSave }) => {
  const classes = useStyles();

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [notaView, setNotaView] = useState({ id: null, open: false });
  const [manutencoes, setManutencoes] = useState([]);
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (open) {
      setValues({
        criadoPor: authData.id,
        criadoPorName: authData.nome,
        dataInclusao: moment().format("DD/MM/YYYY HH:mm:ss"),
      });
    } else {
      setValues({});
      setManutencoes([]);
      setReadOnly(false);
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findHistoricoById(id);
  }, [id, findHistoricoById]);

  useEffect(() => {
    if (id && selectedHistoricoVeiculo && id === selectedHistoricoVeiculo.id) {
      setValues(selectedHistoricoVeiculo);
      setManutencoes(selectedHistoricoVeiculo.manutencoes || []);
      setReadOnly(selectedHistoricoVeiculo.readOnly);
    }
  }, [id, selectedHistoricoVeiculo]);

  const onSave = () => {
    const erros = validate(values, getSchema(values.tipoHistorico));
    setErrors(erros);
    if (!erros) {
      upsertHistorico({
        ...values,
        veiculo: idVeiculo,
        manutencoes,
      }, saveCallback);
    }
  }

  const saveCallback = (success, data) => {
    if (success) {
      setValues({});
      onCloseLocal(true);
      afterSave(data);
    }
  }

  const onCloseLocal = isSave => {
    setErrors({});
    onClose(isSave);
    setNotaView({ id: null, open: false });
  }

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleChangeTipo = event => {
    setValues({ tipoHistorico: event.target.value })
    setErrors({});
  };

  const titleData = () => {
    switch (values.tipoHistorico) {
      case 'MANUTENCAO':
        return 'Data da Manutenção'
      case 'PECAS':
        return 'Data da Compra'
      case 'MULTA':
        return 'Data e Hora da Multa'
      case 'AUTUACAO':
        return 'Data e Hora da Autuação'
      case 'REPASSE_COLABORADOR':
        return 'Data da Entrega'
      case 'VENDA_TROCA':
        return 'Data da Transferência'
      default:
        return 'Data'
    }
  }

  const titleObservacao = () => {
    switch (values.tipoHistorico) {
      case 'VENDA_TROCA':
        return 'Negociação (Observação)'
      default:
        return 'Observação'
    }
  }

  return (
    <DialogDefault
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Histórico do Veículo"
      confirmMessage="Salvar"
      contentClassName={classes.contentClassName}
      maxWidth="md"
    >
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={3} className={classes.fieldContainer}>
          <DefaultSelect
            error={errors && errors.tipoHistorico ? true : false}
            isRequired
            label="Tipo do Histórico"
            name="tipoHistorico"
            showEmpty
            options={[
              { id: 'AUTUACAO', nome: 'Autuação' },
              { id: 'MANUTENCAO', nome: 'Manutenção' },
              { id: 'MULTA', nome: 'Multa' },
              { id: 'PECAS', nome: 'Peças' },
              { id: 'REPASSE_COLABORADOR', nome: 'Repasse' },
              { id: 'VENDA_TROCA', nome: 'Venda/Troca' },
            ]}
            onSelect={handleChangeTipo}
            value={values.tipoHistorico}
            disabled={readOnly}
          />
        </Grid>
        {values.tipoHistorico && values.tipoHistorico !== "MULTA" && values.tipoHistorico !== "AUTUACAO" &&<Grid item xs={3} className={classes.fieldContainer}>
          <DatePicker
            label={titleData()}
            error={errors && errors.dataHistorico ? true : false}
            onChange={data => setValues({
              ...values,
              dataHistorico: data.valueOf()
            })}
            value={values.dataHistorico}
            disabled={readOnly}
          />
        </Grid>}
        {values.tipoHistorico && (values.tipoHistorico === "MULTA" || values.tipoHistorico === "AUTUACAO") &&<Grid item xs={3} className={classes.fieldContainer}>
          <DateTimePicker
            label={titleData()}
            error={errors && errors.dataHistorico ? true : false}
            onChange={data => setValues({
              ...values,
              dataHistorico: data.valueOf()
            })}
            value={values.dataHistorico}
            disabled={readOnly}
          />
        </Grid>}
        <Grid item xs={3} className={classes.fieldContainer}>
          <Input
            label="Criado Por"
            disabled
            value={values.criadoPorName}
          />
        </Grid>
        <Grid item xs={3} className={classes.fieldContainer}>
          <Input
            label="Data Inclusão"
            disabled
            value={values.dataInclusao}
          />
        </Grid>
        {values.tipoHistorico === 'MANUTENCAO' && manutencao(values, handleChange, setValues, errors, classes, setNotaView, manutencoes, setManutencoes, readOnly)}
        {values.tipoHistorico === 'PECAS' && pecas(values, handleChange, setValues, errors, classes)}
        {(values.tipoHistorico === 'MULTA' || values.tipoHistorico === 'AUTUACAO') && multa(values, handleChange, setValues, errors, classes)}
        {values.tipoHistorico === 'REPASSE_COLABORADOR' && repasse(values, handleChange, setValues, errors, classes)}
        {values.tipoHistorico === 'VENDA_TROCA' && vendaTroca(values, setValues, errors, classes)}
        {values.tipoHistorico && <Grid item xs={12} className={classes.fieldContainer}>
          <Input
            label={titleObservacao()}
            name="observacao"
            onChange={handleChange}
            value={values.observacao}
            rows={3}
            multiline
            error={errors && errors.observacao && (values.tipoHistorico === 'MANUTENCAO' || values.tipoHistorico === 'VENDA_TROCA')  ? true : false}
          />
        </Grid>}
        <ArquivoContainer
          arquivos={values.arquivos}
          onSave={arquivos => setValues({ ...values, arquivos })}
          disabled={readOnly}
        />
      </Grid>
      <NotaFormulario 
        id={notaView.id}
        open={notaView.open}
        onClose={() => setNotaView({ id: null, open: false })}
        isAdmin={false}
      />
    </DialogDefault>
  );
};

const mapStateToProps = state => ({
  selectedHistoricoVeiculo: selectorsVeiculos.getSelectedHistoricoVeiculo(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsVeiculos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
